class B2BMarkupSummaryModel {
    constructor(b2BMarkupSummaries) {
        this.B2BMarkupSummaries = [];

        if (!Array.isArray(b2BMarkupSummaries)) {
            console.warn('B2BMarkupSummaryModel: Expected array but received:', typeof b2BMarkupSummaries);
            return;
        }

        this.B2BMarkupSummaries = b2BMarkupSummaries
            .filter(markup => markup && typeof markup === 'object')
            .map(markup => this.transformMarkup(markup));
    }

    transformMarkup(markup) {
        return {
            Id: markup.Id || null,
            Name: markup.Name || "N/A",
            Code: markup.Code || "N/A",
            Type: markup.Type || "N/A",
            Priority: Number(markup.Priority) || 0,
            Status: markup.Status === true ? "Active" : "Inactive",
            CreatedAt: markup.CreatedAt || null,
            DateBandCount: Number(markup.DateBandCount) || 0
        };
    }
}

export default B2BMarkupSummaryModel;